import React from 'react'
import { Fragment } from 'react'
import { Container, Row, Col, Card, CardHeader, Button, CardBody, Collapse, Form, Label, FormGroup, Input } from 'reactstrap'
import { ModalAnalizerInterfaces } from '../../../components/analyzerInterfacex/ModalAnalizerInterfaces'
import { TableStriped } from '../../../components/tables/TableStriped'
import { useAnalyzerInterface } from '../../../hooks/analyzerInterface/useAnalyzerInterface'
import Select from 'react-select';
import { TitleDataTable } from '../../../components/tableDataTable/TitleDataTable';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

export const IndexAnalyzerInterface = () => {

    const {
        filterAnalyzer, setFilterAnalyzer,
        handleChangeBranch,
        listMachineModels, listBranch,
        analyzerInterface,
        totalPageCount, currentPage, nextPage, previousPage, goToPage,
        handleGetAnalyzer,
        loading, handleSearchAppCode,
        toggle, modal, handleUpdate,
        appCode, handleInputChange, saveUpdate,
        selectBranch, selectAnalyzer,

        // * SEARCH AND DOWNLOAD EXCEL
        handleClearAppCode, searchAppCode, 
        loadingExcel, handleExcelAppCode

    } = useAnalyzerInterface();

    ////console.log(analyzerInterface);
  const headerStyle = {
        backgroundColor: "#1d5b83",
        color: "#fff",
        fontWeight: "bold",
        fontSize: "11px",
        borderRight: "1px solid #fff",
        borderBottom: "2px solid #fff",
    };

    const cellStyle = {
        fontSize: "11px",
        padding: "8px",
        textAlign: "center",
        fontFamily: "Montserrat, sans-serif",
        lineHeight: "1.8",
        color: "#353535"
    };

    const centerStyle = {
        ...cellStyle,
        textAlign: "center",
    };

    const actions = (rowData) => {

        return (
            <div className="d-flex justify-content-center align-items-center" style={{ gap: "3px", marginRight: "3px" }}>
                <Button
                    size="sm"
                    onClick={() => handleUpdate(rowData.id_app_code)}
                    title="Editar sucursal"
                    className="btnTableAction"
                >
                    <i className="fa fa-edit iconTableAction"></i>
                </Button>
            </div>
        );
    };

    return (
        <Fragment>
            <Container fluid={true}>
                <div className='container-global-zoom'>
                    <Card style={{
                        marginBottom: '15px',
                        background: 'linear-gradient(135deg, #002940 0%, #1d5b83 100%)',
                        border: 'none',
                        boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
                    }}>
                        <CardBody style={{ padding: '18px 25px' }}>
                            <div className="d-flex align-items-center justify-content-between">
                                <div className="d-flex align-items-center">
                                    <div style={{
                                        width: '60px',
                                        height: '50px',
                                        borderRadius: '12px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        marginRight: '15px'
                                    }}>
                                        <img alt="flask" className="img-fluid text-info mr-2" src={require("../../../assets/images/laboratory-External/config.png")} style={{ width: "60px", height: "60px" }} />
                                    </div>
                                    <div>
                                        <h4 className="mb-1" style={{ color: '#fff', fontWeight: 700, fontSize: '20px', textAlign: "justify" }}>
                                            Configurar Apps
                                        </h4>
                                        <small style={{ color: 'rgba(255, 255, 255, 0.85)', fontSize: '13px' }}>
                                            <i className="fa fa-info-circle mr-1"></i>
                                            Gestión y edición de App Codes por sucursal y analizador  
                                        </small>
                                    </div>
                                </div>
    
                            </div>
                        </CardBody>
                    </Card>

                    
                    <Card className='shadow-sm border height-equal pricingtable mb-0 pb-0 p-1'>
                        <Col sm="12" >
                            <Row>
                                <Col sm="2" className='p-l-0 p-r-0' style={{ textAlign: "left" }}>
                                    <Card style={{
                                        boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                                        border: 'none',
                                        height: '100%',
                                        borderRadius: '12px'
                                    }}>
                                        <CardHeader style={{
                                            background: 'linear-gradient(135deg, #0d3b59 0%, #1d5b83 100%)',
                                            color: 'white',
                                            padding: '15px',
                                            borderRadius: '12px 12px 0 0'
                                        }}>
                                            <h6 className="mb-0" style={{ fontWeight: 700, fontSize: '15px' }}>
                                                <i className="fa fa-filter mr-2"></i>Filtros de Búsqueda
                                            </h6>
                                        </CardHeader>
                                        <CardBody style={{ padding: '20px' }}>
                                            <FormGroup>
                                                <Label>Sucursal</Label>

                                                <Select
                                                    name="selectBranch"
                                                    isClearable={true}
                                                    placeholder="Selecciona una sucursal"
                                                    options={listBranch}
                                                    onChange={(e) => handleChangeBranch(e, 'selectBranch')}
                                                    value={selectBranch}
                                                    className="select-branch"
                                                    menuPortalTarget={document.body}
                                                    styles={{
                                                        menuPortal: (base) => ({
                                                            ...base,
                                                            zIndex: 99999
                                                        })
                                                    }}
                                                />
                                            </FormGroup>
                                            <FormGroup>
                                                <Label className='f-w-600 label-report'>
                                                    <i className="fa fa-calendar-check mr-2" style={{ color: '#28a745' }}></i>Analizador
                                                </Label>
                                                 <Select
                                                    name="selectAnalyzer"
                                                    isClearable={true}
                                                    placeholder="Selecciona un analizador"
                                                    options={listMachineModels}
                                                    onChange={(e)=>handleChangeBranch(e,'selectAnalyzer')}
                                                    value={selectAnalyzer}
                                                    className="select-analyzer"
                                                    menuPortalTarget={document.body}
                                                    styles={{
                                                        menuPortal:(base)=>({
                                                            ...base,
                                                            zIndex:99999
                                                        })
                                                    }}
                                                />
                                            </FormGroup>

                                            <br />
                                            <b>Acciones</b>
                                            <br /><br />
                                            <Button
                                                onClick={() => handleGetAnalyzer()}

                                                color="primary"
                                                block
                                                outline
                                                className="mb-3"
                                                style={{
                                                    borderRadius: '10px',
                                                    padding: '6px',
                                                    fontSize: '14px',
                                                    fontWeight: 600,
                                                    borderWidth: '2px'
                                                }}
                                                disabled={loading}
                                                onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-2px)'}
                                                onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                                            >
                                                {loading ? (
                                                    <>
                                                        <i className="pi pi-spin pi-spinner"></i>&ensp;Buscando...
                                                    </>
                                                ) : "Filtrar"}
                                                
                                            </Button>

                                        </CardBody>


                                    </Card>
                                </Col>

                                <Col sm="10">

                                <Card>
                                    <CardBody className="p-1">
                                        <TitleDataTable
                                            titleTable="Listado de App codes para interfaz"
                                            buttonActions={handleExcelAppCode}
                                            titleButton="Excel de indicaciones"
                                            isDisbled={loadingExcel}
                                            loadingIsDisabled={loadingExcel}
                                            titleCreate="Crear indicación para pacientes"
                                            showCreateButton={false}
                                            actionInput={handleSearchAppCode}
                                            valueFilter={searchAppCode}
                                            filterLocalStorage={true}
                                            cleanFilterLocalStorage={handleClearAppCode}
                                        />
        
                                        <div className="table-responsive">
                                            <DataTable
                                                value={analyzerInterface}
                                                paginator
                                                rows={10}
                                                responsiveLayout="scroll"
                                                rowsPerPageOptions={[10, 50, 100]} 
                                                className="data-table p-datatable-striped p-datatable-sm"
                                                emptyMessage={
                                                    <div className="text-center">
                                                        <img
                                                            src={require("../../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")}
                                                            style={{ width: "32%" }}
                                                            alt="Sin resultados"
                                                        />
                                                        <br />
                                                        <p className="badge badge-light-primary mt-2" style={{ fontSize: "15px" }}>
                                                            No se encontraron resultados.
                                                        </p>
                                                    </div>
                                                }
                                            >
                                                <Column header="#" body={(rowData, options) => { const globalIndex = options.rowIndex; return globalIndex + 1; }} headerStyle={headerStyle} style={centerStyle} />
                                                <Column 
                                                    field="app_code"
                                                    header="APPCODE" 
                                                    sortable
                                                    body={(rowData) => (
                                                        <span style={{ fontWeight: "bold" }}>
                                                            {rowData.app_code}
                                                        </span>
                                                    )}
                                                    headerStyle={headerStyle} 
                                                    style={cellStyle} 
                                                />

                                                <Column 
                                                    field="code_info_analyte"
                                                    header="Nombre corto" 
                                                    sortable
                                                    body={(rowData) => (
                                                        <span >
                                                            {rowData.code_info_analyte}
                                                        </span>
                                                    )}
                                                    headerStyle={headerStyle} 
                                                    style={cellStyle} 
                                                />

                                                <Column 
                                                    field="name_exam"
                                                    header="Examen" 
                                                    sortable
                                                    body={(rowData) => (
                                                        <span>
                                                            {rowData.name_exam}
                                                        </span>
                                                    )}
                                                    headerStyle={headerStyle} 
                                                    style={cellStyle} 
                                                />

                                                <Column 
                                                    field="analyte"
                                                    header="Resultado" 
                                                    body={(rowData) => (
                                                        <span >
                                                            {rowData.analyte}
                                                        </span>
                                                    )}
                                                    headerStyle={headerStyle} 
                                                    style={cellStyle} 
                                                />

                                                <Column 
                                                    field="type_result"
                                                    header="T. Resultado"
                                                    body={(rowData) => (
                                                        <span>
                                                            {rowData.type_result}
                                                        </span>
                                                    )}
                                                    headerStyle={headerStyle} 
                                                    style={cellStyle} 
                                                />
                                                
                                                <Column header="Acciones" body={actions} exportable={false} headerStyle={headerStyle} style={centerStyle} />
                                            </DataTable>
                                        </div>
                                    </CardBody>
                                </Card>
                                
                                </Col>

                            </Row>
                        </Col>
                    </Card>
                </div>
                
            </Container>
            <ModalAnalizerInterfaces
                {
                ...{
                    modal, toggle, loading,
                    handleInputChange, appCode, saveUpdate
                }
                }
            />
        </Fragment>
    )
}
